import { useEffect, useState } from 'react';
import api from '../utils/api';
import { useBranding } from '../hooks/useBranding';
import { useAuth, isTTC } from '../hooks/useAuth';

// Very small changelog renderer: ## / ### headings, - bullets, **bold**, paragraphs.
function renderMarkdown(md) {
  const lines = md.split('\n');
  const out = [];
  let list = null;
  const inline = (text) => {
    const parts = text.split(/(\*\*[^*]+\*\*|`[^`]+`)/g).filter(Boolean);
    return parts.map((p, i) => {
      if (p.startsWith('**') && p.endsWith('**')) return <strong key={i}>{p.slice(2, -2)}</strong>;
      if (p.startsWith('`') && p.endsWith('`')) return <code key={i}>{p.slice(1, -1)}</code>;
      return <span key={i}>{p}</span>;
    });
  };
  const flush = () => { if (list) { out.push(<ul key={'ul' + out.length}>{list}</ul>); list = null; } };
  lines.forEach((raw, idx) => {
    const line = raw.replace(/\r$/, '');
    if (/^##\s+/.test(line) && !/^###/.test(line)) { flush(); out.push(<h3 key={idx} style={{ margin: '18px 0 6px', color: 'var(--brand-navy, #031E45)' }}>{inline(line.replace(/^##\s+/, ''))}</h3>); }
    else if (/^###\s+/.test(line)) { flush(); out.push(<h4 key={idx} style={{ margin: '12px 0 4px' }}>{inline(line.replace(/^###\s+/, ''))}</h4>); }
    else if (/^#\s+/.test(line)) { /* top title — skip */ }
    else if (/^[-*]\s+/.test(line)) { list = list || []; list.push(<li key={idx} style={{ marginBottom: 4 }}>{inline(line.replace(/^[-*]\s+/, ''))}</li>); }
    else if (line.trim() === '') { flush(); }
    else { flush(); out.push(<p key={idx} style={{ margin: '6px 0' }}>{inline(line)}</p>); }
  });
  flush();
  return out;
}

export default function Footer() {
  const { footerCompany } = useBranding();
  const { user } = useAuth();
  const [version, setVersion] = useState('');
  const [open, setOpen] = useState(false);
  const [notes, setNotes] = useState(null);

  useEffect(() => {
    api.get('/api/version').then(r => setVersion(r.data.version || '')).catch(() => {});
  }, []);

  const canView = isTTC(user);

  const openNotes = () => {
    setOpen(true);
    if (notes === null) {
      api.get('/api/version/notes')
        .then(r => setNotes(r.data.markdown || ''))
        .catch(() => setNotes(''));
    }
  };

  const year = new Date().getFullYear();
  const company = footerCompany || 'Toledo Ticket Technologies';
  const label = `Toledo Ticket OMS${version ? ` v${version}` : ''}`;

  return (
    <footer className="app-footer">
      <span className="app-footer-copy">© {year} {company}. All rights reserved.</span>
      {canView
        ? <button className="app-footer-version" onClick={openNotes}
            style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'inherit', font: 'inherit', textDecoration: 'underline' }}
            title="View release notes">{label}</button>
        : <span className="app-footer-version">{label}</span>}

      {open && (
        <div className="modal-overlay" onClick={() => setOpen(false)}>
          <div className="modal" style={{ maxWidth: 680, maxHeight: '80vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Release Notes</h3>
              <button className="btn btn-ghost btn-sm" onClick={() => setOpen(false)}>✕</button>
            </div>
            <div className="modal-body" style={{ overflow: 'auto', fontSize: 14, lineHeight: 1.5 }}>
              {notes === null ? <div className="loading">Loading…</div>
                : notes ? renderMarkdown(notes)
                : <p className="text-muted">No release notes available.</p>}
            </div>
          </div>
        </div>
      )}
    </footer>
  );
}
